import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { GraphType, GraphCategory } from '../../views/report-details/interfaces/report-details.interface';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private scheduleReportSubject = new BehaviorSubject<any>({ show: false });
  scheduleReportState = this.scheduleReportSubject.asObservable();

  private generateReportSubject = new BehaviorSubject<any>({ show: false });
  generateReportForm = this.generateReportSubject.asObservable();

  private graphReportSubject = new BehaviorSubject<any>([]);
  graphReportState = this.graphReportSubject.asObservable();

  private reportLevelSecuritySubject = new BehaviorSubject<any>({ show: false });
  reportLevelSecurityForm = this.reportLevelSecuritySubject.asObservable();

  private emailReportSubject = new BehaviorSubject<any>({ show: false });
  emailReportState = this.emailReportSubject.asObservable();

  private getSavedReportDataSubject = new Subject<any>();
  getSavedReportDataState = this.getSavedReportDataSubject.asObservable();

  private defaultGraphTypeSubject = new Subject<any>();
  defaultGraphTypeState = this.defaultGraphTypeSubject.asObservable();


  private allGraphItems:any[] = [
    {
      label: 'Graphs',  //graph_type 1 single y axis,graph_type 2 multi graph
      items: [
        {
          identity: GraphType.LINE_CHART,
          graph_type: GraphCategory.MULTI_GRAPH,
          type: 0,
          label: 'Line',
          image: 'assets/images/line.svg',
          class: 'active'
        },
        {
          identity: GraphType.STACKED_COLUMN_CHART,
          graph_type: GraphCategory.MULTI_GRAPH,
          type: 0,
          label: 'Stacked Column',
          image: 'assets/images/clustered-column.svg'
        },
        {
          identity: GraphType.STACKED_AREA_CHART,
          graph_type: GraphCategory.MULTI_GRAPH,
          type: 0,
          label: 'Stacked Area',
          image: 'assets/images/stacked-area.svg'
        },
        {
          identity: GraphType.RANGE_AREA_CHART,
          graph_type: GraphCategory.MULTI_GRAPH,
          type: 0,
          label: 'Range Area',
          image: 'assets/images/range-area.svg'
        },
        {
          identity: GraphType.NESTED_DONUT_CHART,
          graph_type: GraphCategory.MULTI_GRAPH,
          type: 0,
          label: 'Nested Donut',
          image: 'assets/images/nested-donut.svg'
        },
        {
          identity: GraphType.CLUSTERED_COLUMN_CHART,
          graph_type: GraphCategory.MULTI_GRAPH,
          type: 0,
          label: 'Clustered Column',
          image: 'assets/images/clustered-column.svg'
        },
        {
          identity: GraphType.PIE_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Pie',
          image: 'assets/images/pie.svg'
        },
        {
          identity: GraphType.SEMI_CIRCLE_PIE_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Semi Circle Pie',
          image: 'assets/images/semi-circle-pie.svg'
        },
        {
          identity: GraphType.DONUT_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Donut',
          image: 'assets/images/donut.svg'
        },
        {
          identity: GraphType.PYRAMID_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Pyramid',
          image: 'assets/images/pyramid.svg'
        },
        {
          identity: GraphType.BAR_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Bar',
          image: 'assets/images/bar.svg'
        },
        {
          identity: GraphType.COLUMN_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Column',
          image: 'assets/images/column.svg'
        },
        {
          identity: GraphType.CURVED_COLUMN_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Curved Column',
          image: 'assets/images/curved-column.svg'
        },
        {
          identity: GraphType.SMOOTHED_LINE_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Smoothed Line',
          image: 'assets/images/smoothed-line.svg'
        },
        {
          identity: GraphType.STEP_LINE_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Step line',
          image: 'assets/images/step-line.svg'
        },
        {
          identity: GraphType.FUNNEL_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Funnel',
          image: 'assets/images/funnel.svg'
        },
        {
          identity: GraphType.LOLLIPOP_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Lollipop',
          image: 'assets/images/lollipop.svg'
        },
        {
          identity: GraphType.DRAGGABLE_PIE_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Draggable Pie',
          image: 'assets/images/draggable-pie.svg'
        },
        {
          identity: GraphType.SPIRAL_BAR_TIMELINE_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Spiral Bar Timeline',
          image: 'assets/images/spiral-bar-timeline.svg'
        },
        {
          identity: GraphType.SPIRAL_TIMELINE_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Spiral Timeline',
          image: 'assets/images/spiral-timeline.svg'
        },
        {
          identity: GraphType.FISHBONE_TIMELINE_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Fishbone',
          image: 'assets/images/fishbone.svg'
        },
        {
          identity: GraphType.SERPENTINE_TIMELINE_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Serpentine Timeline',
          image: 'assets/images/serpentine-timeline.svg'
        },
        {
          identity: GraphType.ROAD_TIMELINE_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Road Timeline',
          image: 'assets/images/road-timeline.svg'
        },
        {
          identity: GraphType.LINEAR_TIMELINE_CHART,
          graph_type: GraphCategory.SINGLE_Y_AXIS,
          type: 0,
          label: 'Linear Timeline',
          image: 'assets/images/linear-timeline.svg'
        }
      ]
    }
  ];

  private generateReportData: any = {};
  private _formLoaded: boolean = false;
  private _scheduleReportData: any = {};
  private _graphReportData: any = {};
  private _reportLevelSecurityData: any = {};
  private _emailReportData: any = {};
  private _reloadSavedReportData: any = {};
  constructor() {
  }

  /**
   * This function is used to show the schedule report
  * @author Anil on 31/07/2025
   */
  showScheduleReport() {
    this.scheduleReportSubject.next({ show: true });
  }

  /**
   * This function is used to hide the schedule report
   * @author Anil on 31/07/2025
   */
  hideScheduleReport() {
    this.scheduleReportSubject.next({ show: false });
  }

  /**
   * This function is used to show the email report form
   * @author Assistant on 2025
   */
  showEmailReport() {
    this.emailReportSubject.next({ show: true });
  }

  /**
   * This function is used to hide the email report form
   * @author Assistant on 2025
   */
  hideEmailReport() {
    this.emailReportSubject.next({ show: false });
  }

  /**
   * This function used to show the generate report form
   * @author Raghavender P On 12-Jun-2025
   */
  showGenerateReportForm(data: any = {}, hideChildModules: boolean = false) {
    this.generateReportSubject.next({ show: true, hideChildModules });
  }
  /**
   * This function used to hide the generate report form
   * @author Raghavender P On 12-Jun-2025
   */
  hideGenerateReportForm() {
    this.generateReportSubject.next({ show: false });
  }

  set setReportData(data: any) {
    this.generateReportData = data;
  }
  get getReportData() {
    return this.generateReportData;
  }

  /**
   * Getter for formLoaded property
   * @author Raghavender P On 12-Jun-2025
   */
  get formLoaded(): boolean {
    return this._formLoaded;
  }

  /**
   * Setter for formLoaded property
   * @author Raghavender P On 12-Jun-2025
   */
  set formLoaded(value: boolean) {
    this._formLoaded = value;
  }



  // to display the graph by report data
  set setGraphReportData(data: any) {
    this._graphReportData = data;
  }
  get getGraphReportData() {
    return this._graphReportData;
  }

  /**
   * Update the graph report state to emit data to all graph components
   * @param data - New graph report data
   */
  updateGraphReportState(data: any): void {
    this.graphReportSubject.next(data);
  }

  reportSecurityState = new BehaviorSubject<any>({ show: false });
  reportSecurityState$ = this.reportSecurityState.asObservable();

  set scheduleReportData(data: any) {
    this._scheduleReportData = data;
  }

  get scheduleReportData() {
    return this._scheduleReportData;
  }

  set reportLevelSecurityData(data: any) {
    this._reportLevelSecurityData = data;
  }

  get reportLevelSecurityData() {
    return this._reportLevelSecurityData;
  }

  set emailReportData(data: any) {
    this._emailReportData = data;
  }

  get emailReportData() {
    return this._emailReportData;
  }

  showReportLevelSecurity() {
    this.reportLevelSecuritySubject.next({ show: true });
  }

  hideReportLevelSecurity() {
    this.reportLevelSecuritySubject.next({ show: false });
  }

  set setReloadSavedReportData(data: any) {
    this._reloadSavedReportData = data;
  }

  get getReloadSavedReportData() {
    return this._reloadSavedReportData;
  }

  triggerGetSavedReportData() {
    const dataToEmit = {
      ...this.getReloadSavedReportData,
      timestamp: Date.now() // Add unique timestamp
    };
    this.getSavedReportDataSubject.next(dataToEmit);
  }

  clearReloadSavedReportData() {
    this._reloadSavedReportData = {};
  }


  get getAllGraphItems() {
    return this.allGraphItems;
  }

  getAllGraphItemsArray(columnsCount: number) {
    const count = columnsCount ?? 0;
    let allGraphItemsArray: any[] = [];
    this.allGraphItems.forEach((item: any) => {
      item.items
        .filter((graphItem: any) => this.isGraphTypeAllowedForColumns(graphItem.identity, count))
        .forEach((graphItem: any) => {
          allGraphItemsArray.push({ code: graphItem.identity, name: graphItem.label });
        });
    });
    return allGraphItemsArray;
  }

  getGraphCategory(graphType: string): GraphCategory | undefined {
    for (const group of this.allGraphItems) {
      const graphItem = group.items?.find((item: any) => item.identity === graphType);
      if (graphItem) {
        return graphItem.graph_type;
      }
    }
    return undefined;
  }

  isGraphTypeAllowedForColumns(graphType: string, columnsCount: number): boolean {
    if (!graphType || columnsCount < 1) {
      return true;
    }
    const category = this.getGraphCategory(graphType);
    if (category === undefined) {
      return true;
    }
    return columnsCount === 1 || category === GraphCategory.MULTI_GRAPH;
  }

  set defaultGraphType(data: any) {
    this.defaultGraphTypeSubject.next(data);
  }

  get defaultGraphType() {
    return this.defaultGraphTypeSubject.asObservable();
  }

  clearDefaultGraphType() {
    this.defaultGraphTypeSubject.next(null);
  }
}